import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import DevicesMarquee from "../components/DevicesMarquee";
import Services from "../components/Services";
import Process from "../components/Process";
import Stats from "../components/Stats";
import Gallery from "../components/Gallery";
import ServiceAreas from "../components/ServiceAreas";
import FAQ from "../components/FAQ";
import BlogSection from "../components/BlogSection";
import Reviews from "../components/Reviews";
import FacebookFeed from "../components/FacebookFeed";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import { useSeo, DEFAULT_TITLE } from "../lib/seo";
import { heroImage } from "../mock";

const HomePage = () => {
  useSeo({
    title: DEFAULT_TITLE,
    description:
      "Repairzone Π.Κ: επισκευή κινητών, laptop, tablet, υπολογιστών & gaming consoles στη Λαμία και σε όλη τη Φθιώτιδα κατ' οίκον. Αλλαγή οθόνης από 25€, δωρεάν διάγνωση, 6 μήνες εγγύηση. Τηλ. 6982917870.",
    path: "/",
    image: heroImage,
  });
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in");
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <DevicesMarquee />
      <Services />
      <Process />
      <Stats />
      <ServiceAreas />
      <Gallery />
      <Reviews />
      <BlogSection />
      <FAQ />
      <FacebookFeed />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
